module.exports = __webpack_public_path__ + "img/num.a2ee746c.svg";